<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001538')"
							paramKey="pmcId"
							@commInput="setPopupSearchParam"
							:clearable="false"
							:propData="popupSearchParams.pmcId"
							:readonly="true"
							:placeholder="getMessage_('QWCC001656')"
						>
						</search-input>
					</el-col>
					<el-col :span="2">
						<search-input :label="getMessage_('QWCC002107')" paramKey="ipnNos" :propData="popupSearchParams.ipnNos" :readonly="true">
						</search-input>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: { scrId: { type: String, default: '' } },
	async created() {
		this.custList = [
			{ label: this.getMessage_('QWCC001476'), value: 'Y' },
			{ label: this.getMessage_('QWCC001763'), value: 'N' }
		];
		await this.searchList();
	},
	components: { SearchInput },
	methods: {
		...rootMethods,
		...serviceMethods,
		refresh() {
			this.$emit('Refresh');
		},
		setPopupSearchParam(param) {
			if (param.key === 'pmcId') {
				this.setPopupSearchParam_({ key: 'ipnNos', value: '' });
			}
			this.setPopupSearchParam_(param);
		},
		
		
		async searchList() {
			try {
				if (!this.isMqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				if (!this.popupSearchParams.pmcId)
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000974')]));
				this.$sf_toggleLoading(true);
				await this.getPopupList_();

			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
